import { Typography } from "antd";
import { cx } from "class-variance-authority";

import { useApplicationBarVariant } from "./ApplicationBarVariant";
import * as theme from "./Breadcrumbs.css";

export interface BreadcrumbsLabelProps {
    children: string;
    /**
     * The page the user is on, always the last crumb. Defaults to `false`.
     */
    current?: boolean;
}

export function BreadcrumbsLabel({
    children,
    current = false,
}: BreadcrumbsLabelProps) {
    const variant = useApplicationBarVariant();
    const flatCurrent = current && variant === "flat";

    return (
        <Typography.Text
            ellipsis={{ tooltip: children }}
            className={cx(
                theme.label[variant],
                flatCurrent && theme.flatLabelCurrent
            )}
            aria-current={current ? "page" : undefined}
        >
            {children}
        </Typography.Text>
    );
}
